<template>
  <div>
    <!-- :get-form-data="fromData" -->
    <list
      row-key="ScheduleId"
      ref="list"
      unit="用户"
      :expand-all-row="true"
      :page="page"
      :show-checkbox="true"
      :show-query="false"
      :query-params="params"
      :get-data-func="api.list"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="table">
        <slot name="column"></slot>
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/trend/list";
import list from "@/components/common/trendsTable/list";
import tableColumn from "@/data/sy/personnel/shift/list.json";
export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
      api: require("@/api/ba/schedule").default,
      params: {},
    };
  },
  methods: {
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>
